import Icon from 'veui/components/Icon'
import { IconIntelligence } from 'dls-icons-vue'

Icon.register('intelligence', IconIntelligence)
